import i18n from '@src/i18n'
const t = i18n?.global.t
import { FEATURES_ENVIRONMENT } from '@src/services/.env.js'
export const DOMAIN_TITLE = 'MyQampus'
const generalConstants = {
  MAX_WORD_LENGTH: 35,
  TIME_ZONE: ' GMT +08:00',
  MINUTES: ' Minutes',
  imageSize: 500,
  RECORD_LIMIT: 10,
  RECORD_LIMIT_FOR_FILTERS: 500,
  RECORD_SKIP: 0,
  EMPTY_RECORD: 0,
  MODAL_RECORD_LIMIT: 5,
  NOT_APPLICABLE: 'N/A',
  FOR_ALL_CAMPUSES: 'For All Campuses',
  PASS: 'pass',
  FAIL: 'fail',
  emailSetupMessage: 'Are you sure you want to send password setup email to ',
  LESSON_TYPES: ['Theory', 'Lab', 'Assignment'],
  NO_RECORD_FOUND: 'No Record found',
  DAY_RANGE: ['monday', 'sunday'],
  TIME_RANGE: ['0:00 am', '0:00 am'],
  WEEK_START_DAY: 'Monday',
  MONTH: 'Month',
  WEEK: 'Week',
  DAY: 'Day',
  EMPTY_RECORD_STRING: '',
  AMOUNT_ZERO: '0',
  LOGIN_ENABLED: 'Login Enabled',
  LOGIN_DISABLED: 'Login Disabled',
  PUBLISHED: 'Published',
  NOT_PUBLISHED: 'Not Published',
  GENERATED: 'Generated',
  NOT_GENERATED: 'Not Generated',
  LEARN_MORE: 'Learn More',
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  BLANKED: '- -',
  ACTIVE: 'Active',
  NOT_ACTIVE: 'Not Active',
  STATS_AND_SUMMARY: 'Stats and Summary',
  STUD_INFO: 'Student Information',
  LESS_THAN: 'Less Than',
  GREATER_THAN: 'Greate Than',
  GENDERS: ['male', 'female', 'other'],
  BLOOD_GROUP: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],
  SECTION: 'Section',
  CLASS: 'Class',
  CAMPUS: 'Campus',
  INSTITUTE: 'Institute',
}

export const CALENDER_VIEWS = {
  MONTH: 'Month',
  WEEK: 'Week',
  DAY: 'Day',
}

export const SCOPE_LEVELS = {
  ROOT_LEVEL: 'root-level',
  CAMPUS_LEVEL: 'campus-level',
  CLASS_LEVEL: 'class-level',
  SECTION_LEVEL: 'section-level',
}
export const ATTENDANCE = {
  ABSENT: 'absent',
  PRESENT: 'present',
  TARDY: 'tardy',
}
export const FEATURES = {
  PICKUP: 'pickup',
}
export const FEATURES_TABS_LIST =
  FEATURES_ENVIRONMENT === 'prod'
    ? [{ key: 'general', name: 'General' }]
    : [
        { key: 'general', name: 'General' },
        { key: 'permission', name: 'Permission' },
        { key: 'notification', name: 'Notification' },
      ]
export const FEATURES_TABS = {
  GENERAL: 'general',
  PERMISSION: 'permission',
  NOTIFICATION: 'notification',
}

export const ENV = {
  DEV: 'dev',
  LOCAL: 'local',
  PROD: 'prod',
}

export const IDENTITY_TYPE_OPTIONS = [
  { title: t(`dashboard.TM_P2_DD2_O1_L1`), value: 'cnic' },
  { title: t(`dashboard.TM_P2_DD2_O2_L2`), value: 'driving_licence' },
  { title: t(`dashboard.TM_P2_DD2_O3_L3`), value: 'passport' },
]
export const ROLES_LIST = [
  { id: '0', name: 'Student' },
  { id: '1', name: 'Teacher' },
  { id: '2', name: 'Gaurdian' },
  { id: '3', name: 'Staff' },
  { id: '4', name: 'All Student' },
  { id: '5', name: 'All Teacher' },
  { id: '6', name: 'All Gaurdian' },
  { id: '7', name: 'All Staff' },
]

export const MEDIUM_LIST = [
  { id: '1', name: 'email' },
  { id: '2', name: 'sms' },
]

/**
 * User Constants
 */
export const USER_CONSTANTS = {
  GENDERS: [
    { title: 'Male', value: 'male' },
    { title: 'Female', value: 'female' },
  ],
  MAJOR_ROLES: [
    { title: 'Section Teacher', value: 'section_teacher' },
    { title: 'Super Admin', value: 'super_admin' },
    { title: 'Campus Admin', value: 'campus_admin' },
    { title: 'Campus Moderator', value: 'campus_moderator' },
  ],
  LOGIN_ENABLED_STATUSES: [
    { title: 'Enable', value: true },
    { title: 'Disable', value: false },
  ],
}

export const NOTIFICATION_STATUS = {
  READ: 'read',
  UNREAD: 'Unread',
  READ_ALL_SMALL: 'read',
  UNREAD_ALL_SMALL: 'unread',
}

export const COMMUNICATION_MEDIUMS = {
  WEBPUSH: 'webpush',
  SMS: 'sms',
  EMAIL: 'email',
  SOCKET: 'socket',
}

export const weekDays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
export const NOTIFICATION_COMMUNICATION_MEDIUMS_LIST = [
  { id: '1', name: 'email' },
  { id: '2', name: 'sms' },
  { id: '3', name: 'webpush' },
]
export const RESULT_GENERATED_LIST = [
  { title: 'Generated', value: 'generated' },
  { title: 'Not Generated', value: 'not_generated' },
]
export const RESULT_PUBLISHED_LIST = [
  { title: 'Published', value: 'yes' },
  { title: 'Not Published', value: 'no' },
]
export const BROWSERS = {
  FIREFOX: 'Firefox',
  EDGE: 'Edge',
  CHROME: 'Chrome',
  SAFARI: 'Safari',
  OPERA: 'Opera',
  UNKNOWN: 'Unknown',
}
export const capitalTimezones = {
  af: 'Asia/Kabul', // Kabul, Afghanistan
  al: 'Europe/Tirane', // Tirana, Albania
  dz: 'Africa/Algiers', // Algiers, Algeria
  ao: 'Africa/Luanda', // Luanda, Angola
  ar: 'America/Argentina/Buenos_Aires', // Buenos Aires, Argentina
  au: 'Australia/Sydney', // Canberra uses Sydney timezone
  at: 'Europe/Vienna', // Vienna, Austria
  bd: 'Asia/Dhaka', // Dhaka, Bangladesh
  be: 'Europe/Brussels', // Brussels, Belgium
  br: 'America/Sao_Paulo', // Brasília uses São Paulo timezone
  ca: 'America/Toronto', // Ottawa uses Toronto timezone
  ch: 'Europe/Zurich', // Bern uses Zurich timezone
  cn: 'Asia/Shanghai', // Beijing uses Shanghai timezone
  cz: 'Europe/Prague', // Prague, Czech Republic
  de: 'Europe/Berlin', // Berlin, Germany
  dk: 'Europe/Copenhagen', // Copenhagen, Denmark
  eg: 'Africa/Cairo', // Cairo, Egypt
  es: 'Europe/Madrid', // Madrid, Spain
  fi: 'Europe/Helsinki', // Helsinki, Finland
  fr: 'Europe/Paris', // Paris, France
  gb: 'Europe/London', // London, UK
  gh: 'Africa/Accra', // Accra, Ghana
  gr: 'Europe/Athens', // Athens, Greece
  hu: 'Europe/Budapest', // Budapest, Hungary
  id: 'Asia/Jakarta', // Jakarta, Indonesia
  ie: 'Europe/Dublin', // Dublin, Ireland
  il: 'Asia/Jerusalem', // Jerusalem, Israel
  in: 'Asia/Kolkata', // New Delhi uses Kolkata timezone
  iq: 'Asia/Baghdad', // Baghdad, Iraq
  ir: 'Asia/Tehran', // Tehran, Iran
  it: 'Europe/Rome', // Rome, Italy
  jp: 'Asia/Tokyo', // Tokyo, Japan
  ke: 'Africa/Nairobi', // Nairobi, Kenya
  kr: 'Asia/Seoul', // Seoul, South Korea
  kz: 'Asia/Almaty', // Astana/Nur-Sultan uses Almaty timezone
  ma: 'Africa/Casablanca', // Rabat uses Casablanca timezone
  mx: 'America/Mexico_City', // Mexico City, Mexico
  my: 'Asia/Kuala_Lumpur', // Kuala Lumpur, Malaysia
  ng: 'Africa/Lagos', // Abuja uses Lagos timezone
  nl: 'Europe/Amsterdam', // Amsterdam, Netherlands
  no: 'Europe/Oslo', // Oslo, Norway
  np: 'Asia/Kathmandu', // Kathmandu, Nepal
  nz: 'Pacific/Auckland', // Wellington uses Auckland timezone
  pk: 'Asia/Karachi', // Islamabad uses Karachi timezone
  pl: 'Europe/Warsaw', // Warsaw, Poland
  pt: 'Europe/Lisbon', // Lisbon, Portugal
  ro: 'Europe/Bucharest', // Bucharest, Romania
  ru: 'Europe/Moscow', // Moscow, Russia
  sa: 'Asia/Riyadh', // Riyadh, Saudi Arabia
  se: 'Europe/Stockholm', // Stockholm, Sweden
  sg: 'Asia/Singapore', // Singapore
  th: 'Asia/Bangkok', // Bangkok, Thailand
  tr: 'Europe/Istanbul', // Ankara uses Istanbul timezone
  ua: 'Europe/Kyiv', // Kyiv, Ukraine
  us: 'America/New_York', // Washington D.C. uses New York timezone
  ve: 'America/Caracas', // Caracas, Venezuela
  vn: 'Asia/Ho_Chi_Minh', // Hanoi uses Ho Chi Minh timezone
  za: 'Africa/Johannesburg', // Pretoria uses Johannesburg timezone
}

export default generalConstants
